import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import InvoiceView from '@/components/InvoiceView';
import { RefreshCcw } from 'lucide-react';

export default function FounderInvoicePage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = async (isRefresh = false) => {
    if (isRefresh) setRefreshing(true);
    try {
      const res = await api.get('/founders/payment-status');
      setData(res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); setRefreshing(false); }
  };
  useEffect(() => { load(); }, []);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" style={{ color: 'var(--heritage-plum)' }}>
        <div className="h-eyebrow">Loading invoice...</div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-16 text-center" style={{ color: 'var(--heritage-plum)' }}>
        <div className="h-eyebrow">Unable to load</div>
        <div className="h-display text-2xl mt-2">Invoice not found</div>
      </div>
    );
  }

  return (
    <div className="px-4 md:px-6 py-6 md:py-8">
      <div className="max-w-3xl mx-auto mb-4 flex items-center justify-between gap-3 no-print">
        <div>
          <div className="h-eyebrow">Founders Club</div>
          <div className="h-display text-3xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Your Invoice</div>
        </div>
        <button className="h-btn-outline text-xs" onClick={() => load(true)} disabled={refreshing} data-testid="invoice-refresh">
          <RefreshCcw size={12} className={`mr-1.5 ${refreshing ? 'animate-spin' : ''}`} />
          {refreshing ? 'Checking...' : 'Refresh status'}
        </button>
      </div>
      <InvoiceView data={data} canRequestPause={true} onPauseRequested={() => load(true)} />
    </div>
  );
}
